import { Checkbox, FormHelperText, TextField } from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import Autocomplete from '@material-ui/lab/Autocomplete'

import * as R from 'ramda'
import React, { FC, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type Props = {
  fieldName: string
  fieldValue: string
  defaultValue?: string
  rules?: any
  selections: string[]
  required?: boolean
  disable?: boolean
  noSort?: boolean
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

const FormSingleAutoCompleteSelector: FC<Record<string, unknown> & Props> = ({
  fieldName,
  fieldValue,
  defaultValue = '',
  rules = {},
  selections,
  required = false,
  disable = false,
  noSort = false
}) => {
  const { control, setValue } = useFormContext()
  const [selectedValue, setSelectedValue] = useState<string>(
    fieldValue ?? defaultValue
  )
  // TODO: add empty option if not required
  return (
    <Controller
      control={control}
      name={fieldName}
      rules={{ ...rules, required }}
      as={
        <>
          <Autocomplete
            fullWidth
            disabled={disable}
            value={selectedValue}
            defaultValue={defaultValue}
            id={`${fieldName}-single-auto-complete-selector`}
            options={
              noSort ? selections : R.sortBy(R.compose(R.toLower), selections)
            }
            onChange={(_event: React.ChangeEvent<any>, newValue) => {
              setValue(fieldName, newValue)
              setSelectedValue(newValue ?? defaultValue)
            }}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </>
            )}
            renderInput={(params) => <TextField {...params} />}
          />
          {required && <FormHelperText>Required</FormHelperText>}
        </>
      }
    />
  )
}

export default FormSingleAutoCompleteSelector
